// extracted by mini-css-extract-plugin
module.exports = {"items_wrapper":"items_wrapper--3mo0G","item":"item--1gRz4","remove_item":"remove_item--rSZgP","add_item":"add_item--3jVtS","input_new_item":"input_new_item--eZTzB"};